import React, { ReactNode } from "react";
import { Card, Text, Group } from "@mantine/core";
import { cn } from "../../lib/utils";

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: ReactNode;
  gradient?: boolean;
}

export const MetricCard = ({
  title,
  value,
  change,
  changeType = "neutral",
  icon,
  gradient = false,
}: MetricCardProps) => {
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      className={cn(
        "transition-all duration-200 hover:shadow-dashboard border-border/50",
        gradient && "bg-gradient-card"
      )}
    >
      {/* Header */}
      <Group style={{justifyContent: 'space-between'}} mb="xs">
        <Text size="sm" c="dimmed" fw={500}>
          {title}
        </Text>
        <div className="text-muted-foreground">{icon}</div>
      </Group>

      {/* Value */}
      <Text fz="xl" fw={700}>
        {value}
      </Text>

      {/* Change Indicator */}
      {change && (
        <Text
          size="xs"
          mt={4}
          className={cn(
            changeType === "positive" && "text-success",
            changeType === "negative" && "text-destructive",
            changeType === "neutral" && "text-muted-foreground"
          )}
        >
          {change}
        </Text>
      )}
    </Card>
  );
};
